<template>
  <el-dialog
    title="Duplicate Characteristics"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="400px"
    @close="closeDialog()"
  >
    <div>
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="Firmware Ver" prop="FWVersion">
          <el-input v-model="form.FWVersion"></el-input>
        </el-form-item>
        <el-form-item label="Hardware Ver" prop="HWVersion">
          <el-input v-model="form.HWVersion"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-btn min-w-80" @click="save()" :loading="loading">{{
        $t('text.save').toUpperCase()
      }}</el-button>
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        ID: 0,
        FWVersion: '',
        HWVersion: ''
      },
      rules: {
        FWVersion: [
          {
            required: true,
            message: this.$t('text.firmware_version_required')
          }
        ],
        HWVersion: [
          {
            required: true,
            message: this.$t('text.hardware_version_required')
          }
        ]
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
    },
    save() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.CopyProductThreshold(this.form)
            .then(response => {
              this.loading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.saved_successfully')
                })
                this.$parent.getHwVersions(false)
                this.$parent.getFwVersions(false)
                this.$parent.getData()
                this.closeDialog()
              } else {
                swal({
                  icon: 'error',
                  title: this.$t('text.failed'),
                  text: response.data.msg
                })
              }
            })
            .catch(() => {
              this.loading = false
              swal({
                icon: 'error',
                timer: 2000,
                title: this.$t('text.failed')
              })
            })
        }
      })
    },
    resetForm() {
      this.form = {
        ID: 0,
        FWVersion: '',
        HWVersion: ''
      }
      this.$refs['form'].resetFields()
    }
  }
}
</script>
